import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div``;

const Image = styled.img`
  width: 11.5rem;
  height: 11.5rem;
  border-radius: 50%;
  object-fit: cover;
`;

const Logo = ({ image }) => (
  <Wrapper>
    <Image src={image} alt="logo" />
  </Wrapper>
);

export default Logo;
